import {
  Controller,
  Control,
  FieldValues,
  DeepMap,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { Tooltip } from '@mui/material';

interface TextInput2Props {
  label: string;
  name: string;
  control: Control<any>;
  required?: boolean;
  errors?: DeepMap<FieldValues, FieldError>;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  type?: string;
  inputProps?: any;
  defaultValue?: any;
  className?: string;
  multiline?: boolean;
  disabled?: boolean;
  tooltip?: string;
  children?: React.ReactNode;
}

export default function TextInput2({
  label,
  name,
  control,
  required = false,
  errors,
  rules = undefined,
  type = 'text',
  inputProps = undefined,
  defaultValue = undefined,
  className = undefined,
  multiline = false,
  disabled = false,
  tooltip = '',
  children,
}: TextInput2Props) {
  // const allInputProps = {
  //   ...inputProps,
  //   'box-shadow': '0px 3px 6px rgba(1, 16, 18, 0.15);',
  // };
  return (
    <Controller
      name={name as any}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      render={({ field }) => (
        <Tooltip title={tooltip || ''} placement="bottom">
          <TextField
            className={className}
            {...field}
            label={label}
            multiline={multiline}
            required={required}
            variant="outlined"
            helperText={errors ? errors[name]?.message : undefined}
            type={type}
            inputProps={inputProps}
            error={errors ? !!errors[name] : false}
            disabled={disabled}>
            {children}
          </TextField>
        </Tooltip>
      )}
    />
  );
}
